import { postRequestJson } from '../request/apiRequest';


const AddressGeocodingServices = {
    updateAddressCoordinates: async (address) => {
        return await postRequestJson('/activities-details/update-address-coordinates', {
            address: address
        });
    },

    getCoordinatesForAddress: async (address) => {
        return await postRequestJson('/activities-details/update-address-coordinates', {
            address: address
        });
    }
};

export default AddressGeocodingServices; 